import GeographyService from "@app/geography/geographyService";
import { ServicingProvider } from "@app/projects/results/servicing-provider";
import { toast } from "@app/projects/servicing-provider/DistanceResultToast";

export const handleDistanceClick = async (selectedProviders: ServicingProvider[], toastId: string): Promise<void> => {
  if (selectedProviders.length === 2) {
    const fromProvider = selectedProviders[0];
    const toProvider = selectedProviders[1];
    const distance = await (new GeographyService()).getDrivingDistance(fromProvider.longitude, fromProvider.latitude, toProvider.longitude, toProvider.latitude);

    toast(distance, toastId);
  }
}
